/**
 * Created by Ivo Mehide <ivo@degeetia.ee> on 01.10.17.
 */

import _ from "underscore";

/**
 * @typedef {Object} PageAction
 * @property {?string} icon Action icon
 * @property {?string} label Action text
 * @property {string} action Action type
 * @property {?string} href Action link
 * @property {?String} btnClass Action button class
 * @property {?bool} isPrimary Is this the default action
 * @property {?LocationProps} params Location parameters
 * @property {?object} data Action data
 * @property {?string} access Access right for this action
 */

/**
 * Page action
 */
class PageAction {
    /**
     *
     * @param {PageAction} action
     */
    constructor(action) {
        this.setAction(action);
    }

    /**
     * @protected
     * @param {PageAction} action
     */
    setAction(action) {
        if (action) {
            this.icon = action.icon;
            this.label = action.label;
            this.action = action.action;
            this.href = action.href;
            this.params = action.params;
            this.data = action.data;
            this.action = action.action;
            this.btnClass = action.btnClass;
            this.isPrimary = action.isPrimary;
            this.access = action.access;
        } else {
            this.icon = null;
            this.label = null;
            this.action = null;
            this.href = null;
            this.params = null;
            this.data = null;
            this.action = null;
            this.btnClass = null;
            this.isPrimary = false;
            this.access = null;
        }
    }
}

/**
 * Class for representing link action. Used fields:
 *  - "action" - always value "link"
 *  - "href" - link URL: only PATH part for UI navigation or full URL for navigating to external sites
 */
class LinkAction extends PageAction {
    /**
     *
     * @param {PageAction} action
     */
    constructor(action) {
        super(_.extend({}, action, {action: "link"}));
    }
}

class GotoBackAction extends PageAction {
    /**
     *
     * @param {PageAction} action
     */
    constructor(action) {
        super(_.extend({}, action, {action: "back"}));
    }
}

class DeleteResourceAction extends PageAction {
    /**
     *
     * @param {PageAction} action
     */
    constructor(action) {
        super(_.extend({}, action, {action: "delete"}));
    }
}

class UpdateResourceAction extends PageAction {
    /**
     *
     * @param {PageAction} action
     */
    constructor(action) {
        super(_.extend({}, action, {action: "update"}));
    }
}

class SubmitAction extends PageAction {
    /**
     *
     * @param {PageAction} action
     */
    constructor(action) {
        super(_.extend({}, action, {action: "submit"}));
    }
}

class ChangeAuthCodeAction extends PageAction {
    constructor(action) {
        super(_.extend({}, action, {action: "changeAuthCode"}));
    }
}

class RefreshAction extends PageAction {
    constructor(action) {
        super(_.extend({}, action, {action: "refresh"}));
    }
}

class GotoRecordAction extends PageAction {
    constructor(action, recordNo) {
        super(_.extend({}, action, {action: "gotoRecord"}));
        if (recordNo != null) this.data = {firstRecord: recordNo};
    }
}

class SetPageSizeAction extends PageAction {
    constructor(action, size) {
        super(_.extend({}, action, {action: "setPageSize"}));
        if (size != null) this.data = {pageSize: size};
    }
}

class SetSortAction extends PageAction {
    constructor(action, sort) {
        super(_.extend({}, action, {action: "setSort"}));
        if (sort != null) this.data = {sort: sort};
    }
}

class SetFilterAction extends PageAction {
    constructor(action, filter) {
        super(_.extend({}, action, {action: "setFilter"}));
        if (filter != null) this.data = {filter: filter};
    }
}

export {PageAction, GotoBackAction, DeleteResourceAction, UpdateResourceAction, SubmitAction, RefreshAction, GotoRecordAction, SetSortAction, SetFilterAction, SetPageSizeAction};
